import React from 'react'

import exclamationPointIcon from './assets/exclamationpoint.svg'
import questionIcon from './assets/questionmark.svg'
import questionIconLight from './assets/questionmark_light.svg'
import * as S from './styles'

import type { TooltipIconProps } from './types'
import type { FC } from 'react'

export const TooltipIcon: FC<TooltipIconProps> = (props) => {
  const {
    iconSvg,
    iconLight = false,
    isWarning = false,
    id,
    customTooltipIcon,
    'data-testid': dataTestId,
  } = props

  const defaultSvg = () => {
    if (iconLight) return questionIconLight
    if (isWarning) return exclamationPointIcon
    return questionIcon
  }

  const icon = iconSvg ?? defaultSvg()

  return customTooltipIcon ? (
    <div id={id} data-testid={dataTestId}>
      {customTooltipIcon}
    </div>
  ) : (
    <S.TooltipIcon iconSvg={icon} id={id} data-testid={dataTestId} />
  )
}
